var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.419,
    height: 24.413,
    viewBox: "0 0 24.419 24.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calender-svgrepo-com_1_",
    "data-name": "calender-svgrepo-com (1)",
    d: "M22.893,2.4h-6.11V.876a.763.763,0,1,0-1.526,0V2.4h-6.1V.876a.763.763,0,1,0-1.526,0V2.4h-6.1A1.526,1.526,0,0,0,0,3.923V23a1.526,1.526,0,0,0,1.526,1.526H22.893A1.526,1.526,0,0,0,24.419,23V3.923A1.526,1.526,0,0,0,22.893,2.4Zm0,20.6H1.526V3.923h6.1v.769a.763.763,0,1,0,1.526,0V3.923h6.1v.769a.763.763,0,1,0,1.526,0V3.923h6.11ZM17.551,12.317h1.526a.763.763,0,0,0,.763-.763V10.028a.763.763,0,0,0-.763-.763H17.551a.763.763,0,0,0-.763.763v1.526A.763.763,0,0,0,17.551,12.317Zm0,6.1h1.526a.763.763,0,0,0,.763-.763V16.132a.763.763,0,0,0-.763-.763H17.551a.763.763,0,0,0-.763.763v1.526A.763.763,0,0,0,17.551,18.421Zm-4.579-3.052H11.446a.763.763,0,0,0-.763.763v1.526a.763.763,0,0,0,.763.763h1.526a.763.763,0,0,0,.763-.763V16.132A.764.764,0,0,0,12.972,15.369Zm0-6.1H11.446a.763.763,0,0,0-.763.763v1.526a.763.763,0,0,0,.763.763h1.526a.763.763,0,0,0,.763-.763V10.028A.763.763,0,0,0,12.972,9.265Zm-6.1,0H5.342a.763.763,0,0,0-.763.763v1.526a.763.763,0,0,0,.763.763H6.868a.763.763,0,0,0,.763-.763V10.028A.763.763,0,0,0,6.868,9.265Zm0,6.1H5.342a.763.763,0,0,0-.763.763v1.526a.763.763,0,0,0,.763.763H6.868a.763.763,0,0,0,.763-.763V16.132A.764.764,0,0,0,6.868,15.369Z",
    transform: "translate(0 -0.113)",
    fill: "#d5ad67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderEvent);
export default __webpack_public_path__ + "static/media/calender-event.78c4591e45cb7fd9edea4ced4a6eeeaa.svg";
export { ForwardRef as ReactComponent };